import { memone, MutableRecordStore, MutableSetStore } from '@deqo/foundation';
import { HangoutLocation } from './HangoutLocation';
import { HangoutUser } from './HangoutUser';

const template = {
    location: null as HangoutLocation,
    user: null as HangoutUser,
    joinedAt: 0,
    seenAt: 0,
};

export class HangoutClient extends MutableRecordStore(template) {

    constructor(public readonly id: string) {
        super();
    }

}

export class HangoutClientStore extends MutableSetStore<HangoutClient> {

    public get(id: string) {
        return this.getMemoizedIndex(this.state).get(id) || null;
    }

    public reset() {
        this.mutateTo(new Set());
    }

    @memone()
    private getMemoizedIndex(state: Set<HangoutClient>) {
        const index = new Map<string, HangoutClient>();
        for (const x of state) {
            index.set(x.id, x);
        }
        return index;
    }
}
